import React from 'react';
import PropTypes from 'prop-types';
import ConfirmDialogBase from './ConfirmDialogBase';

class ConfirmDialog extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override ConfirmDialogBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Dialog> */
    className: PropTypes.string,
    /** Open/close dialog */
    open: PropTypes.bool.isRequired,
    /** Text for the Dialog title */
    title: PropTypes.string.isRequired,
    /** Text for the cancel button */
    cancelText: PropTypes.string,
    /** Text for the confirm button */
    confirmText: PropTypes.string.isRequired,
    /** Callback fired when cancel button click */
    onCancel: PropTypes.func,
    /** Callback fired when confirm button click */
    onConfirm: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
  };

  getStyles = type => {
    switch (type) {
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <ConfirmDialogBase styles={styles} {...otherProps} />;
  }
}

export default ConfirmDialog;
